import {
  IvideonHistoryCamerasDataResponseIProps,
  IvideonHistoryResponseIProps,
} from "~/entity/Ivideon/model/schema";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

export interface fromServerIProps {
  data: IvideonHistoryResponseIProps;
  t: (props: string) => string;
}

export interface resultIProps {
  id: string | number;
  dateTime: string;
  cameraId: string;
  cameraName: string;
  typeEvent: string;
  comment: string;
  user: string;
}

export const fromServer = ({ data, t }: fromServerIProps): resultIProps[] => {
  const items = data.data as IvideonHistoryCamerasDataResponseIProps[];

  return items.map((item) => {
    const meta = typeof item.metadata === "object" ? item.metadata : null;

    return {
      id: item.id,
      dateTime: dateFormat(item.createdAt, { type: "datetime" }) ?? "",
      typeEvent: t(`ivideonCameras.cameraEvent.${item.action}`),
      cameraName: meta?.cameraName || "",
      cameraId: meta?.cameraIvideonId || "",
      comment: item?.comment || "",
      user: item?.userName || "",
    };
  });
};
